<div class="container-fluid px-0">
  <div class="row my-0 mx-0">
    <div class="col-12 px-0 d-flex justify-content-center">
      <img class="error-logo" [src]="'assets/images/png/page-not-found.png'" [srcset]="'assets/images/png/page-not-found@2x.png 2x, assets/images/png/page-not-found@3x.png 3x'" alt="logo"></div>
    <div class="col-12 px-0 d-flex justify-content-center"><label class="service-error-header">
      Sayfa Bulunamadı!
      <!--      {{this.textService.keyValueMapping('pageNotFoundHeader', 'Sayfa Bulunamadı')}}-->
    </label>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center"><label class="service-error-message">
      Gitmek istediğiniz url'i maalesef bulamadık, kontrol edip tekrar dener misiniz.
      <!--      {{this.textService.keyValueMapping('pageNotFoundDescription', 'Gitmek istediğiniz url\'i maalesef bulamadık, kontrol edip tekrar dener misiniz.')}}-->
    </label></div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="path"></div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <pa-redirect></pa-redirect>
    </div>
  </div>
</div>
